'use client';

import { FC } from 'react';
import Slider from 'react-slick';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { Divider, Typography } from '@mui/material';

import Iconify from '../../../../components/iconify';
import { ComponentTypeProps } from '../../../../types/page-generator';
import Image from '../../../../components/image';

export const BannersCarouselWithButton: FC<ComponentTypeProps> = ({ block }) => {
  const actionButtons: any = block?.actionButtons || [];
  const combined: any = block?.combined;
  let sliderRef: Slider | any;
  const text: string = block?.text as string;

  const CustomPrevArrow = ({ onClick }: any) => (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        right: '-40px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 100,
      }}
    >
      <Iconify icon="ep:arrow-left-bold" color="rgba(14, 23, 50, 1)" />
    </Box>
  );

  const CustomNextArrow = ({ onClick }: any) => (
    <Box
      onClick={onClick}
      sx={{
        backgroundColor: 'transparent',
        position: 'absolute',
        top: '50%',
        left: '-40px',
        transform: 'translateY(-50%)',
        cursor: 'pointer',
        zIndex: 100,
      }}
    >
      <Iconify icon="ep:arrow-right-bold" color="rgba(14, 23, 50, 1)" />
    </Box>
  );

  const handlePrevClick = () => {
    sliderRef.slickPrev();
  };

  const handleNextClick = () => {
    sliderRef.slickNext();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    nextArrow: <CustomPrevArrow onClick={handlePrevClick} />,
    prevArrow: <CustomNextArrow onClick={handleNextClick} />,
  };

  return (
    <Box
      sx={{
        '& .slick-track': { mt: '10px' },
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
        <Typography sx={{ fontSize: '22px', fontWeight: 800 }}>{text}</Typography>
        {actionButtons.length > 0 && (
          <Stack direction="row" alignItems="center">
            <Typography sx={{ mr: 1 }}>{actionButtons[0]?.label}</Typography>
          </Stack>
        )}
      </Stack>
      <Divider sx={{ my: 2 }} />

      <Slider {...settings}>
        {combined?.map((item: { image: string }, id: number) => (
          <Box key={id} sx={{ px: 0.5 }}>
            <Image src={item?.image} />
          </Box>
        ))}
      </Slider>
    </Box>
  );
};
